import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import { isWeb } from 'shared/constants/platform';
import theme from 'shared/styles/theme';

const FDICDisclaimer = ({ disclaimerCopy }: { disclaimerCopy?: string }) => {
  const { width } = useWindowDimensions();
  const { t: translatedText } = useTranslation('componentsStrings', {
    keyPrefix: 'fdicDisclaimerStrings',
  });
  const isSmallScreen = width < 385;

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.fdicWrapper,
          isSmallScreen ? styles.fdicWrapperSmallScreens : null,
        ]}
      >
        <View style={styles.fdicImageContainer}>
          <Icon
            iconKey="FDIC"
            iconSize={38}
            iconColor={theme.color.text.primary}
          />
        </View>
        <BodySmText numberOfLines={3} allowFontScaling={false}>
          {disclaimerCopy || translatedText('fdicInfo')}
        </BodySmText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignContent: 'center',
    alignSelf: 'center',
    justifyContent: 'flex-end',
    marginTop: 'auto',
    marginVertical: theme.spacing.m,
  },
  fdicImageContainer: {
    alignSelf: 'flex-start',
    position: 'relative',
    top: 3,
  },
  fdicWrapper: {
    alignItems: 'flex-start',
    alignSelf: 'center',
    flexDirection: 'row',
    gap: theme.spacing.s,
    justifyContent: 'flex-start',
    width: isWeb ? '80%' : '65%',
  },
  fdicWrapperSmallScreens: {
    width: '75%',
  },
});

export default FDICDisclaimer;
